// extracted by mini-css-extract-plugin
module.exports = {"content":"SectionContentForButton-module--content--16ITb","centered":"SectionContentForButton-module--centered--1dXCb"};